import { create } from 'zustand';

interface EnterpriseUpgradeTourState {
  pending: boolean;
  requestTour: () => void;
  clearPending: () => void;
}

export const useEnterpriseUpgradeTourStore = create<EnterpriseUpgradeTourState>((set) => ({
  pending: false,
  requestTour: () => set({ pending: true }),
  clearPending: () => set({ pending: false }),
}));
